// ** Imports createContext function
import { createContextualCan } from '@casl/react'
import { createContext } from 'react'

// ** Imports createContextualCan function

// ** Create Context
export const AbilityContext = createContext()

// ** Init Can Context
export const Can = createContextualCan(AbilityContext.Consumer)
